import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import UpdatePropState from "../../context/updatePropState";

export class ProposalSuccess extends Component {
  static contextType = UpdatePropState;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount = () => {
    this.context();
  };

  render() {
    return (
      <div>
        <h1>Thank You For Your Submission!</h1>
        <p style={{ marginTop: "50px" }}>
          To view the status of a proposal please navigate to the Submissions
          page by clicking the Submissions button below. We may reach out to you
          if we have any questions.
        </p>
        <p></p>
        <p>
          Contact Support:
          <br />
          <a
            style={{ marginLeft: "10px" }}
            href="mailto:proposals@vicuscapital.com"
          >
            proposals@vicuscapital.com
          </a>
          <br />
          <span style={{ marginLeft: "10px" }}>(855) 558-4287</span>
          <br />
        </p>
        <NavLink to="/proposals">
          <button className="btn btn-secondary">Home</button>
        </NavLink>
        <NavLink to="/submissions" style={{ float: "right" }}>
          <button className="btn btn-success">Submissions</button>
        </NavLink>
      </div>
    );
  }
}

export default ProposalSuccess;
